<template>
  <div>
    <div v-if="started">
      <div id="puzzle-container"></div>
      <div class="fixed z-[10000] w-full h-full top-0 left-0 flex items-center justify-center" v-if="finished">
        <div class="fixed w-full h-full bg-gray-500 opacity-50"></div>
        <div class="relative z-2 w-full xs:w-full md:w-1/3 bg-white p-8 mx-auto rounded-xl flex flex-col items-center">
          <p class="text-xl pb-4">Brawo, udało Ci się ułożyć wszystkie elementy układanki!</p>
          <img :src="imageUrl" class="border-black border border-solid" width="500"/>
          <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-4" @click="runAgain">Zagraj ponownie</button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="puzzle-container">
        <img :src="imageUrl" class="border-black border border-solid" width="500"/>
        <div class="grid grid-cols-2 gap-2">
          <button class="quiz-button text-black bg-white hover:bg-gray-100 mt-4" @click="randImage">Losuj inny obrazek</button>
          <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-4" @click="startPuzzle">Rozpocznij układankę</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRandomOtherThan} from "@/helpers";

export default {
  props: {
    set: {
      type: String,
      default: (() => 'przedszkola')
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      screenWidth: window.innerWidth,
      randomDigit: null,
      finished: false,
      started: false,
      sets: {
        'przedszkola': {h: 4, v: 3, size: 180},
        '1-4': {h: 4, v: 4, size: 140},
        '5-8': {h: 6, v: 4, size: 120},
      },
      loadedCanvas: null,
    }
  },
  computed: {
    imageUrl() {
      return `${this.baseUrl}images/puzzles/${this.set}/puzzle-0${this.randomDigit}.jpg`
    }
  },
  methods: {
    randImage() {
      this.randomDigit = getRandomOtherThan(this.randomDigit, 1, 6)
    },
    runAgain() {
      this.started = false
      this.finished = false
      this.randImage()
    },
    rescale() {
      if (this.loadedCanvas === null) {
        return
      }

      var container = document.getElementById('puzzle-container');
      this.loadedCanvas.resize(container.offsetWidth, container.scrollHeight);
      this.loadedCanvas.scale(container.offsetWidth / 1000);
      this.loadedCanvas.redraw();
    },
    startPuzzle() {
      const $this = this
      $this.started = true
      $this.finished = false
      const selectedSet = this.sets[this.set]
      let dali = new Image();
      dali.src = $this.imageUrl;
      dali.onload = () => {
        $this.loadedCanvas = new headbreaker.Canvas('puzzle-container', {
          width: 1000,
          height: 700,
          image: dali,
          pieceSize: selectedSet.size,
          proximity: 5,
          borderFill: 0,
          strokeWidth: 1,
          lineSoftness: 0.12,
          outline: new headbreaker.outline.Rounded(),
          maxPiecesCount: {x: selectedSet.h, y: selectedSet.v}
        });
        $this.loadedCanvas.adjustImagesToPuzzleWidth();
        $this.loadedCanvas.autogenerate({
          horizontalPiecesCount: selectedSet.h,
          verticalPiecesCount: selectedSet.v
        });
        $this.loadedCanvas.shuffle(0.8);
        $this.loadedCanvas.draw();
        $this.loadedCanvas.attachSolvedValidator();
        $this.loadedCanvas.onValid(() => {
          $this.finished = true
        })
        this.rescale()

        window.addEventListener('resize', this.rescale);
        window.addEventListener('DOMContentLoaded', this.rescale);
      }
    }
  },
  mounted() {
    this.randImage()
  }
}
</script>

<style>
#puzzle-container, .puzzle-container {
  display: flex;           /* establish flex container */
  flex-direction: column;  /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center;     /* center items horizontally, in this case */
  margin:0 auto;
  border-radius: 10px;
  max-width: 1000px;
  min-height: 600px;
  overflow: hidden;
  background-size:cover;
  background-position: center center;
  @apply bg-gray-100
}
</style>